import { Get } from "./api";
import { ApiRoutes } from "enums";

export const getWatcher = async ({ watcherId }) => {
  const res = await Get(`${ApiRoutes.USER}/watchlist/watcher/${watcherId}`);
  return res.data;
};
